import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ServiceBusComponent } from "./service-bus.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "service-bus",
    component: ServiceBusComponent,
    canActivate: [MsalGuard],
    /*children: [
      {
        path: "tenants",
        component: TenantsComponent,
        canActivate: [MsalGuard]
      },
      {
        path: "environments",
        component: EnvironmentsComponent,
        canActivate: [MsalGuard]
      },
      {
        path: "services",
        component: ServicesComponent,
        canActivate: [MsalGuard]
      }
    ]*/
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceBusRoutingModule {}
